import { render, staticRenderFns } from "./CardNivelLista.vue?vue&type=template&id=14e37851&scoped=true&"
import script from "./CardNivelLista.vue?vue&type=script&lang=js&"
export * from "./CardNivelLista.vue?vue&type=script&lang=js&"
import style0 from "./CardNivelLista.vue?vue&type=style&index=0&id=14e37851&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e37851",
  null
  
)

export default component.exports